import React from 'react';

/**
 * DualBanner 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const DualBannerProperties = [
  {
    group: '배너 이미지 설정',
    icon: 'image',
    properties: [
      {
        name: 'componentProps.images',
        label: '배너 이미지',
        control: 'ImageArrayUpload',
        defaultValue: [],
        helper: '2개 이상의 이미지를 업로드하면 랜덤하게 2개가 선택됩니다',
        itemFields: [
          {
            name: 'imageUrl',
            label: '이미지 URL',
            control: 'ImageUpload',
            required: true
          },
          {
            name: 'linkUrl',
            label: '링크 URL',
            control: 'Text',
            placeholder: 'https://example.com'
          },
          {
            name: 'linkTarget',
            label: '링크 타겟',
            control: 'Select',
            options: [
              { value: '_self', label: '현재 창' },
              { value: '_blank', label: '새 창' }
            ],
            defaultValue: '_self'
          },
          {
            name: 'altText',
            label: '대체 텍스트',
            control: 'Text',
            placeholder: '이미지 설명'
          }
        ]
      }
    ]
  },
  {
    group: '텍스트 콘텐츠',
    icon: 'font',
    properties: [
      {
        name: 'componentProps.leftContent',
        label: '왼쪽 이미지 텍스트',
        control: 'RichEditor',
        defaultValue: '',
        richEditorSettings: {
          showPreview: true
        }
      },
      {
        name: 'componentProps.rightContent',
        label: '오른쪽 이미지 텍스트',
        control: 'RichEditor',
        defaultValue: '',
        richEditorSettings: {
          showPreview: true
        }
      }
    ]
  },
  {
    group: '오버레이 설정',
    icon: 'palette',
    properties: [
      {
        name: 'componentProps.overlayColor',
        label: '오버레이 색상',
        control: 'ColorPicker',
        defaultValue: '#000000'
      },
      {
        name: 'componentProps.overlayOpacity',
        label: '오버레이 불투명도',
        control: 'Slider',
        min: 0,
        max: 1,
        step: 0.1,
        defaultValue: 0.3,
        valueFormat: 'percentage'
      },
      {
        name: 'componentProps.textColor',
        label: '텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      }
    ]
  },
  {
    group: '크기 설정',
    icon: 'ruler',
    properties: [
      {
        name: 'componentProps.height',
        label: '높이 (px)',
        control: 'Number',
        min: 200,
        max: 800,
        defaultValue: 400,
        deviceSpecific: true
      },
      {
        name: 'componentProps.gap',
        label: '이미지 간격 (px)',
        control: 'Number',
        min: 0,
        max: 50,
        defaultValue: 10,
        deviceSpecific: true
      }
    ]
  }
];

export default DualBannerProperties;